import { mount } from 'svelte';
import App from './App.svelte';
import { initializeAuthentication } from './auth.js';

async function bootstrap() {
	try {
		const authentication = await initializeAuthentication();
		mount(App, {
			target: document.body,
			props: authentication
		});
	} catch (error) {
		mount(App, {
			target: document.body,
			props: {
				authError: error instanceof Error ? error.message : String(error)
			}
		});
	}
}

bootstrap();
